'use strict';

import { mediaTimeForFrame, playbackFrameNumber } from './trialLiveLayout';

const FALLBACK_FPS = 30;

/**
 * Text fields and selects keep arrow keys. The timeline is a range input,
 * so arrows step a frame instead of nudging the native slider step.
 */
export function trialScrubBlockedTarget(target) {
  if (!target || typeof target.tagName !== 'string') return false;
  const tag = target.tagName;
  if (tag === 'TEXTAREA' || target.isContentEditable) return true;
  if (tag === 'SELECT') return true;
  if (tag !== 'INPUT') return false;
  const type = String(target.getAttribute('type') || 'text').toLowerCase();
  if (type === 'range' || type === 'button' || type === 'submit' || type === 'checkbox' || type === 'radio') {
    return false;
  }
  return true;
}

/** 1 to step forward, -1 to step back, or null when the key should be left alone. */
export function trialScrubStep(event) {
  if (!event || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return null;
  if (trialScrubBlockedTarget(event.target)) return null;
  if (event.key === 'ArrowRight') return 1;
  if (event.key === 'ArrowLeft') return -1;
  return null;
}

/** Next frame index, clamped to the frames the player can show. */
export function trialScrubFrame(frame, frameCount, step) {
  const current = Number.isFinite(frame) ? Math.floor(frame) : 0;
  const delta = step === -1 ? -1 : 1;
  let next = current + delta;
  if (next < 0) next = 0;
  if (Number.isFinite(frameCount) && frameCount >= 1 && next > Math.floor(frameCount) - 1) {
    next = Math.floor(frameCount) - 1;
  }
  return next;
}

/**
 * Media time one frame away from `currentTime`. Missing or unusable rates
 * use 30 fps. The time sits inside the frame so the next press moves exactly once.
 */
export function trialScrubMediaTime(currentTime, frameCount, fps, step) {
  const rate = Number.isFinite(fps) && fps > 1 ? fps : FALLBACK_FPS;
  const frame = playbackFrameNumber(Number.isFinite(currentTime) ? currentTime : 0, rate);
  const next = trialScrubFrame(frame, frameCount, step);
  return mediaTimeForFrame(next, rate);
}
